<template>
  <McButton
    :text="buttonText"
    :disabled="disabled"
    @click="handleCopyText"
    :icon="icon"
    size="sm"
    variant="secondary"
  />
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    toastTitle: { type: String, required: true },
    icon: { type: String, required: true },
    valueToCopy: { type: String, required: true, default: '' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    handleCopyText() {
      navigator.clipboard.writeText(this.valueToCopy)
      this.$mcToast.success(`${this.toastTitle} berhasil disalin`)
    },
  },
}
</script>
